import React from 'react'
import { NumericFormat } from 'react-number-format'
import { TextInput, Typography } from 'gu-ui-kit'
import styles from 'components/FormControls/form-controls.module.scss'
import clsx from 'clsx'

const renderAmountField = ({
  input,
  meta: { touched, error, submitting },
  InputProps = { className: '' },
  placeholder = null,
  ...rest
}) => {
  const locale = global.locale
  const decimalSeparator = locale === 'ru' || locale === 'cn' ? ',' : '.'
  return (
    <NumericFormat
      customInput={TextInput}
      thousandSeparator={' '}
      allowLeadingZeros={true}
      decimalScale={2}
      decimalSeparator={decimalSeparator}
      fixedDecimalScale
      placeholder={placeholder || `0${decimalSeparator}00`}
      {...rest}
      {...input}
      disabled={submitting || rest.disabled}
      helperText={touched && error ? rest.t(error) : rest.helperText}
      error={!!(touched && error)}
      InputProps={{
        className: clsx(styles['input-field'], InputProps.className),
        startAdornment: InputProps.startAdornment,
        endAdornment:
          InputProps.endAdornment ||
          (rest.currency && (
            <Typography variant={'p6'} noMargin color={'text-secondary'}>
              {rest.currency}
            </Typography>
          )),
      }}
    />
  )
}

export default renderAmountField
